import { Component, OnInit } from '@angular/core';
import { AppInformationService, GenesisUnitOfWork } from 'app/core/core.module';
import { PurchaseOrderShipAddress } from 'app/core/model/entity-model';
import { default as validationEngine } from 'devextreme/ui/validation_engine';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { Subject } from 'rxjs';

@Component({
    selector: 'app-purchase-order-ship-address-dialog',
    templateUrl: './purchase-order-ship-address-dialog.component.html',
    styleUrls: ['./purchase-order-ship-address-dialog.component.scss'],
    standalone: false
})
export class PurchaseOrderShipAddressDialogComponent implements OnInit {
    result: Subject<any> = new Subject<any>();
    address: PurchaseOrderShipAddress;
    displayOrder: number;

    constructor(public modalRef: BsModalRef, private uow: GenesisUnitOfWork, private appInfo: AppInformationService) {}

    async ngOnInit() {
        await this.getData();
    }

    async getData() {
        if (!this.address) {
            this.address = this.uow.purchaseOrderShipAddresses.createEntity({
                displayOrder: this.displayOrder,
            }) as PurchaseOrderShipAddress;
        }
    }

    async save() {
        if (!this.validate()) return;
        this.result.next({ success: true });
    }

    close() {
        this.uow.rollback();
        this.result.next({ success: false });
    }

    validate() {
        const groupConfig = validationEngine.getGroupConfig('mainValidationGroup');
        if (groupConfig) {
            const result = validationEngine.validateGroup('mainValidationGroup');
            if (!result.isValid) {
                let message = '';
                result.brokenRules.forEach((brokenRule) => {
                    if (brokenRule.type === 'custom') message = `${brokenRule.message}\n${message}`;
                });
                this.appInfo.notifyToast(`Please fix errors before saving.\n\n${message}`, 'error');
                return false;
            }
        }
        return true;
    }
}
